import { EmptyState } from "@/components/EmptyState/EmptyState";
import { EmptyDeletedSvg, EmptyDesignsSvg, NoDesignIssuesSvg, NoDesignsDownloadedSvg } from "@/components/Icon/Icon";
import { getTab } from "@/store/slices/tabSlice";
import { RootState } from "@/store/store";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export const DesignTableEmptyState = () => {
  const { t } = useTranslation("cases");
  const tabPath = "cases";
  const tab = useSelector((state: RootState) => getTab(state, tabPath));

  const emptyStateMap: Record<string, { image: JSX.Element; header: string; paragraph: string }> = {
    designed: {
      image: <EmptyDesignsSvg />,
      header: t("table.emptyState.designed.header"),
      paragraph: t("table.emptyState.designed.paragraph")
    },
    issues: {
      image: <NoDesignIssuesSvg />,
      header: t("table.emptyState.issues.header"),
      paragraph: t("table.emptyState.issues.paragraph")
    },
    downloaded: {
      image: <NoDesignsDownloadedSvg />,
      header: t("table.emptyState.downloaded.header"),
      paragraph: t("table.emptyState.downloaded.paragraph")
    },
    all: {
      image: <EmptyDesignsSvg />,
      header: t("table.emptyState.all.header"),
      paragraph: t("table.emptyState.all.paragraph")
    },
    rejected: {
      image: <EmptyDeletedSvg />,
      header: t("table.emptyState.rejected.header"),
      paragraph: t("table.emptyState.rejected.paragraph")
    }
  };

  const emptyState = tab && tab in emptyStateMap ? emptyStateMap[tab] : emptyStateMap.all;

  return <EmptyState title={emptyState.header} message={emptyState.paragraph} image={emptyState.image} />;
};
